import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

import FontAwesome from 'utils/FA';

import './styles/SelectPicker.scss';

class SelectPicker extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })),
    value: PropTypes.string,
    onChange: PropTypes.func,
    standardButton: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    options: [],
    value: '',
    standardButton: false,
    disabled: false,

    onChange: () => false
  };

  mounted = false;

  state = {
    open: false
  };

  constructor(props) {
    super(props);

    this.setRef = this.setRef.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }


  UNSAFE_componentWillMount() {
    this.mounted = true;
    global.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    global.removeEventListener('mousedown', this.handleClick, false);
    this.mounted = false;
  }

  setRef(node) {
    this.node = node;
  }

  handleClick(e) {
    const { onChange } = this.props;

    // Only take right clicks
    if (e.button !== 0) {
      return;
    }

    if (this.node && this.node.contains(e.target)) {
      onChange(e.target.value);
    }

    if (this.mounted) {
      this.setState({ open: false });
    }
  }

  render() {
    const {
      className,
      options,
      value,
      standardButton,
      disabled
    } = this.props;

    const { open } = this.state;

    const selected = options.find((o) => o.value === value);

    return (
      <div className={standardButton ? 'select-picker' : 'select-picker select-picker-large'}>
        <div className={classNames(className, 'select-picker-target')}>
          <button
            className={`${standardButton ? 'btn' : ''} ${(options.length > 1) ? '' : 'non-interactive'}`}
            type='button'
            disabled={disabled}
            onClick={() => { this.setState({ open: !open }); }}
          >
            {selected && selected.label}
            {
              options.length > 1 && (
                <FontAwesome icon={faCaretDown} />
              )
            }
          </button>
        </div>
        {
          open && (options.length > 1) &&  (
            <div className='select-picker-dropdown' ref={this.setRef}>
              {
                options.map((o) => (
                  <button
                    key={o.value}
                    className={`select-picker-dropdown-item ${o.value == selected.value ? 'selected' : ''}`}
                    onClick={this.handleClick}
                    value={o.value}
                    defaultValue={selected.value}
                    type='button'
                  >
                    {o.label}
                  </button>
                ))
              }
            </div>
          )
        }
      </div>
    );
  }
}

export default SelectPicker;
